<script lang="ts">
	import { getContext } from 'svelte'
	import type { ActionResult } from '@sveltejs/kit'
	import type { Writable } from 'svelte/store'

	export let cls = ''

	//Props
	export let name: string
	export let value: string
	export let disabled = false
	export let checked = false

	//Stores
	export let fail: Writable<Extract<ActionResult, { type: 'failure' }>> = getContext('fail')
	export let formData: Writable<Record<string, any>> = getContext('formData')

	//Classes
	export let textSize = 'text-sm'
	export let justify = 'justify-start'
	export let alignItems = 'items-center'
	export let margin = 'my-0'
	export let image = '/images/icons/2023_ci/dark/hvac.svg'

	export function focus() {
		inputThis.focus()
		inputThis.select()
	}

	export function fill(val: string) {
		inputThis.value = val
	}

	let inputThis: HTMLInputElement
</script>

<label
	class:border-primary-500={$fail?.data?.[name]}
	class="{cls} {margin} inline-flex cursor-pointer items-center gap-3"
>
	<input
		class="autofill-none hidden"
		class:border-primary-500={$fail?.data?.[name]}
		type="radio"
		bind:group={$formData[name]}
		{name}
		{value}
		{disabled}
		{checked}
		bind:this={inputThis}
		on:click
		on:change={() => {
			if ($fail?.data?.[name]) $fail.data[name] = ''
		}}
	/>
	<div class="wrapper flex gap-2 p-2">
		<img src={image} alt="" class="h-5 w-5" />
		<span class="text-neutral-800 {textSize} {justify} {alignItems} flex flex-auto gap-3">
			<slot />
		</span>
	</div>
</label>

<style>
	.wrapper {
		@apply h-full w-full  items-center rounded-md bg-neutral-300;
	}
	input {
		border: 2px solid theme('colors.neutral.300') !important;
	}

	input:checked ~ .wrapper {
		@apply bg-white;
	}
</style>
